import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cfbb43c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rehab-term" }
const _hoisted_2 = { class: "rehab-term__tail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.head)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString(_ctx.head), 1)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.tail) + " ", 1),
      (_ctx.description)
        ? (_openBlock(), _createBlock(_component_v_tooltip, {
            key: 0,
            text: _ctx.description,
            location: "bottom",
            "max-width": "380"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_icon, _mergeProps(props, {
                size: "x-small",
                class: "ml-1 text-grey",
                "aria-label": "용어 설명"
              }), {
                default: _withCtx(() => [
                  _createTextVNode("help")
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}